import {call, delay, put, takeLatest} from 'redux-saga/effects'
import {ParamsModel} from 'src/app/modules/common/Model'
import {globalActionTypes} from 'src/app/modules/errors/redux/constants'
import {ActionModel} from 'src/cms/helpers/Models/ActionModel'
import {ResponseModel} from 'src/cms/helpers/Models/ResponseModel'
import {SortNabilAuctionCategoryModel, SortSearchActionModel} from '../Model/Model'
import {actions} from './action'
import {actionTypes} from './constants'
import {service} from './service'

function* getNabilAuctionCategorySaga(action: ActionModel) {
  try {
    const params: ParamsModel = action.payload

    yield delay(500)
    const response: ResponseModel = yield call(service.getNabilAuctionCategory, params)
    yield put(actions.getNabilAuctionCategorySuccess(response?.data?.data))
    yield put(actions.getNabilAuctionCategoryFinish())
  } catch (err: any) {
    if (err.response) {
      yield put({
        type: globalActionTypes.GLOBAL_ERROR,
        payload: err.response.data.message,
      })
    }
    yield put(actions.getNabilAuctionCategoryFinish())
  }
}

function* getAllNabilAuctionCategorySaga() {
  try {
    const response: ResponseModel = yield call(service.getAllNabilAuctionCategory)
    yield put(actions.getAllNabilAuctionCategorySuccess(response?.data?.data))
    yield put(actions.getAllNabilAuctionCategoryFinish())
  } catch (err: any) {
    if (err.response) {
      yield put({
        type: globalActionTypes.GLOBAL_ERROR,
        payload: err.response.data.message,
      })
    }
    yield put(actions.getAllNabilAuctionCategoryFinish())
  }
}

function* addNabilAuctionCategorySaga(action: ActionModel) {
  try {
    const body = action.payload
    const response: ResponseModel = yield call(service.addNabilAuctionCategory, body)
    yield put(actions.addNabilAuctionCategorySuccess(response.data?.data))
    yield put(actions.addNabilAuctionCategoryFinish())
  } catch (err: any) {
    if (err.response) {
      yield put({
        type: globalActionTypes.GLOBAL_ERROR,
        payload: err.response.data.message,
      })
    }
    yield put(actions.addNabilAuctionCategoryFinish())
  }
}

function* enableNabilAuctionCategorySaga(action: ActionModel) {
  try {
    const selectedUsers: any = action.payload?.data
    const response: ResponseModel = yield call(service.enableNabilAuctionCategory, selectedUsers)
    yield put(actions.enableNabilAuctionCategorySuccess(response?.data))
    yield delay(100)
    yield put(actions.enableNabilAuctionCategoryFinish())
  } catch (err: any) {
    if (err.response) {
      yield put({
        type: globalActionTypes.GLOBAL_ERROR,
        payload: err.response.data.message,
      })
    }
    yield put(actions.enableNabilAuctionCategoryFinish())
  }
}

function* disableNabilAuctionCategorySaga(action: ActionModel) {
  try {
    const selectedUsers: any = action.payload?.data
    const response: ResponseModel = yield call(service.disableNabilAuctionCategory, selectedUsers)
    yield put(actions.disableNabilAuctionCategorySuccess(response?.data))
    yield delay(100)
    yield put(actions.disableNabilAuctionCategoryFinish())
  } catch (err: any) {
    if (err.response) {
      yield put({
        type: globalActionTypes.GLOBAL_ERROR,
        payload: err.response.data.message,
      })
    }
    yield put(actions.enableNabilAuctionCategoryFinish())
  }
}

function* singleEnableNabilAuctionCategorySaga(action: ActionModel) {
  try {
    const selectedUsers: any = action.payload?.data
    const response: ResponseModel = yield call(service.singleEnableNabilAuctionCategory, selectedUsers)
    yield put(actions.singleEnableNabilAuctionCategorySuccess(response?.data))
    yield delay(100)
    yield put(actions.singleEnableNabilAuctionCategoryFinish())
  } catch (err: any) {
    if (err.response) {
      yield put({
        type: globalActionTypes.GLOBAL_ERROR,
        payload: err.response.data.message,
      })
    }
    yield put(actions.singleEnableNabilAuctionCategoryFinish())
  }
}

function* singleDisableNabilAuctionCategorySaga(action: ActionModel) {
  try {
    const selectedUsers: any = action.payload?.data
    const response: ResponseModel = yield call(service.singleDisableNabilAuctionCategory, selectedUsers)
    yield put(actions.singleDisableNabilAuctionCategorySuccess(response?.data))
    yield delay(100)
    yield put(actions.singleDisableNabilAuctionCategoryFinish())
  } catch (err: any) {
    if (err.response) {
      yield put({
        type: globalActionTypes.GLOBAL_ERROR,
        payload: err.response.data.message,
      })
    }
    yield put(actions.singleDisableNabilAuctionCategoryFinish())
  }
}

function* updateNabilAuctionCategorySaga(action: ActionModel) {
  try {
    const body: any = action.payload
    // const {id, ...newPayload} = body
    const response: ResponseModel = yield call(service.updateNabilAuctionCategory, body, action.payload?.id)
    yield put(actions.updateNabilAuctionCategorySuccess(response.data?.data))
    yield put(actions.updateNabilAuctionCategoryFinish())
  } catch (err: any) {
    if (err.response) {
      yield put({
        type: globalActionTypes.GLOBAL_ERROR,
        payload: err.response.data.message,
      })
    }
    yield put(actions.updateNabilAuctionCategoryFinish())
  }
}

function* deleteNabilAuctionCategorySaga(action: ActionModel) {
  try {
    const body: any = action.payload
    const response: ResponseModel = yield call(service.deleteNabilAuctionCategory, body)
    yield put(actions.deleteNabilAuctionCategorySuccess(response.data?.data))
    yield delay(0.1)
    yield put(actions.deleteNabilAuctionCategoryFinish())
  } catch (err: any) {
    if (err.response) {
      yield put({
        type: globalActionTypes.GLOBAL_ERROR,
        payload: err.response.data.message,
      })
    }
    yield put(actions.deleteNabilAuctionCategoryFinish())
  }
}

function* sortNabilAuctionCategory(action: SortSearchActionModel) {
  try {
    const body: SortNabilAuctionCategoryModel = action.payload
    const response: ResponseModel = yield call(service.sortNabilAuctionCategory, body)

    yield put({
      type: actionTypes.SORT_NABIL_AUCTION_CATEGORY_SUCCESS,
      payload: response?.data?.data,
    })
    yield delay(100)
    yield put({type: actionTypes.SORT_NABIL_AUCTION_CATEGORY_FINISH})
  } catch (err: any) {
    if (err.response) {
      yield put({
        type: globalActionTypes.GLOBAL_ERROR,
        payload: err.response.data.message,
      })
    }
    yield put({type: actionTypes.SORT_NABIL_AUCTION_CATEGORY_FINISH})
  }
}

export function* saga() {
  yield takeLatest(actionTypes.GET_NABIL_AUCTION_CATEGORY_START, getNabilAuctionCategorySaga)
  yield takeLatest(actionTypes.GET_ALL_NABIL_AUCTION_CATEGORY_START, getAllNabilAuctionCategorySaga)
  yield takeLatest(actionTypes.ADD_NABIL_AUCTION_CATEGORY_START, addNabilAuctionCategorySaga)
  yield takeLatest(actionTypes.UPDATE_NABIL_AUCTION_CATEGORY_START, updateNabilAuctionCategorySaga)
  yield takeLatest(actionTypes.DELETE_NABIL_AUCTION_CATEGORY_START, deleteNabilAuctionCategorySaga)
  yield takeLatest(actionTypes.ENABLE_NABIL_AUCTION_CATEGORY_REQUEST, enableNabilAuctionCategorySaga)
  yield takeLatest(actionTypes.DISABLE_NABIL_AUCTION_CATEGORY_REQUEST, disableNabilAuctionCategorySaga)
  yield takeLatest(actionTypes.SINGLE_ENABLE_NABIL_AUCTION_CATEGORY_REQUEST, singleEnableNabilAuctionCategorySaga)
  yield takeLatest(actionTypes.SINGLE_DISABLE_NABIL_AUCTION_CATEGORY_REQUEST, singleDisableNabilAuctionCategorySaga)
  yield takeLatest(actionTypes.SORT_NABIL_AUCTION_CATEGORY_START, sortNabilAuctionCategory)
}
